import { BaseApiService } from "./baseApiService";

export const getApplicationConfiguration = async () => {
    const configService = new ConfigurationService();
    return await configService.getApplicationConfiguration();
}

class ConfigurationService extends BaseApiService {

    constructor() {
        super(null, false);
    }

    async getApplicationConfiguration() {
        return await this.get('configuration');
    }
}